import { ApplicationElement, html } from '../application_element/element.js';
import { spreadProps } from '@open-wc/lit-helpers';

import '../chat_message_reply/element.js';
import translations from './translations.js';
import style from './style.lit.css';

/**
 * This section appears above chat form, and shows the message we are replying to
 *
 * @prop authorName - Author name of the original message
 * @prop body - Body of the original message
 * @prop my - Am I replying to my message?
 */

export default class ChatFormReplyPreview extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    message: { type: Object, attribute: false },
    my: { type: Boolean },
  };

  /** @internal */
  static translations = translations;

  exitReplyMode() {
    this.dispatchEvent(
      new Event('chat-form-reply-preview-exit', {
        bubbles: true,
        composed: true,
      })
    );
  }

  render() {
    if (!this.message) return;

    const replyMessage = { ...this.message, my: this.my };

    return html`
      <ef-chat-message-reply ${spreadProps(replyMessage)}>
      </ef-chat-message-reply>
      <button
        @click=${this.exitReplyMode}
        aria-label=${this.t('exit_reply_mode')}>
        <ef-icon name="close"></ef-icon>
      </button>
    `;
  }
}

ChatFormReplyPreview.registerTagName('ef-chat-form-reply-preview');

customElements.get('ef-chat-form-reply-preview') ||
  customElements.define('ef-chat-form-reply-preview', ChatFormReplyPreview);
